const LoginConfig = {
    poolData: {
        UserPoolId: "us-west-2_zKN2uATm3",
        ClientId: "5sak97arptqfjro6r80l1rgb56"
    }
}
export default LoginConfig;
